// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-gate__loading {
  padding: 48px;
  text-align: center;
  color: #888;
}

.subscription-gate__blocked {
  max-width: 560px;
  margin: 64px auto;
  padding: 0 16px;
  text-align: center;
}

.subscription-gate__blocked h2 {
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionGate.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".subscription-gate__loading {\n  padding: 48px;\n  text-align: center;\n  color: #888;\n}\n\n.subscription-gate__blocked {\n  max-width: 560px;\n  margin: 64px auto;\n  padding: 0 16px;\n  text-align: center;\n}\n\n.subscription-gate__blocked h2 {\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
